// © Microsoft Corporation. All rights reserved.

import {
    ContentActionsToolbarHandledProps as BaseExperienceHandledProps,
    ContentActionsToolbarProps as BaseExperienceProps,
    ContentActionsToolbarManagedClasses,
    ContentActionsToolbarUnhandledProps,
    ToolbarPosition
} from "./ContentActionsToolbar.props";
import {
    ContentActionsToolbarConfigSchema,
    ContentActionsToolbarMockConfig,
    ContentActionsToolbarMockState
} from "./experience-info";
import { ContentActionsToolbarConnectorArgs, ContentActionsToolbarInspector } from "./ContentActionsToolbar.inspector";
import { PlaceHolderId, Status } from "./ContentActionsToolbar.constants";
import manageJss, { ManagedJSSProps } from "@microsoft/fast-jss-manager-react";

import {
    ContentActionsToolbar as BaseExperience
} from "./ContentActionsToolbar";
import { ComponentClass } from "react-redux";
import { ContentActionsToolbarActions } from "./ContentActionsToolbar.actions";
import { ContentActionsToolbarClassNames } from "./ContentActionsToolbar.classnames";
import { ContentActionsToolbarConfig } from "./ContentActionsToolbar.config";
import { ContentActionsToolbarConnector } from "./ContentActionsToolbar.connector";
import { ContentActionsToolbarReducer } from "./ContentActionsToolbar.reducer";
import { ContentActionsToolbarState } from "./ContentActionsToolbar.state";
import { ContentActionsToolbarStyles } from "./ContentActionsToolbar.styles";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { ExperienceInfo } from "@msnews/core";
import { Subtract } from "utility-types";

/*
 * The type returned by manageJss type is very complicated so we'll let the
 * compiler infer the type instead of re-declaring just for the package export
 */
const ContentActionsToolbar = manageJss(ContentActionsToolbarStyles)(BaseExperience);
type ContentActionsToolbar = InstanceType<typeof ContentActionsToolbar>;

// Create a valid JSS managed interface that doesn't require managed classes which are provided by the manageJSS HOC
type ContentActionsToolbarHandledProps = Subtract<BaseExperienceHandledProps, ContentActionsToolbarManagedClasses>;

// Create type for manageJSS HOC styled instance we are exporting
type ContentActionsToolbarProps = ManagedJSSProps<BaseExperienceProps, ContentActionsToolbarClassNames, DesignSystem>;

const ToolingInfo: ExperienceInfo<
ContentActionsToolbarConfig,
ContentActionsToolbarState,
ContentActionsToolbarProps,
ContentActionsToolbarConnectorArgs
> = {
    reactComponent: ContentActionsToolbar,
    experienceConfigSchema: ContentActionsToolbarConfigSchema,
    mockState: ContentActionsToolbarMockState,
    mockConfig: ContentActionsToolbarMockConfig,
    inspector: ContentActionsToolbarInspector.inspect
};

// type for ContentActionsToolbar experience to be invoked by other experiences
type ContentActionsToolbarExp = ComponentClass<ContentActionsToolbarProps>;

// Export everything a user might need from this index file
export {
    ContentActionsToolbar,
    ContentActionsToolbarActions,
    ContentActionsToolbarConfig,
    ContentActionsToolbarConnector,
    ContentActionsToolbarExp,
    ContentActionsToolbarProps,
    ContentActionsToolbarReducer,
    ContentActionsToolbarState,
    ContentActionsToolbarClassNames,
    ContentActionsToolbarHandledProps,
    ContentActionsToolbarUnhandledProps,
    PlaceHolderId,
    Status,
    ToolbarPosition,
    ToolingInfo
};